// extracted by mini-css-extract-plugin
export default {"loading":"notificationsList_loading__e20qV","pcWrap":"notificationsList_pcWrap__GnPhH"};